<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('application_management.approve_list') }} {{$t('globalTrans.search')}}</h4>
      </template>
      <template v-slot:body>
           <b-row>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group
                class="row"
                label-cols-md="12"
                label-cols-lg="4"
                :label="$t('grant_budget_management.fiscal_year')"
                label-for="fiscal_year_id"
              >
                <b-form-select
                plain
                v-model="search.fiscal_year_id"
                :options="fiscalYearList"
                id="fiscal_year_id"
                >
                <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
                </b-form-select>
              </b-form-group>
            </b-col>
           <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                  <b-form-group
                  class="row"
                  label-cols-md="12"
                  label-cols-lg="4"
                  label-for="training_title_id"
                  >
                  <template v-slot:label>
                  {{ $t('elearning_config.training') }}
                  </template>
                  <b-form-select
                  plain
                  v-model="search.training_title_id"
                  :options="trainingNameList"
                  id="training_title_id"
                  >
                  <template v-slot:first>
                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                  </b-form-select>
                  </b-form-group>
          </b-col>
           <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                  <b-form-group
                  class="row"
                  label-cols-md="12"
                  label-cols-lg="4"
                  label-for="org_type_id"
                  >
                  <template v-slot:label>
                  {{ $t('elearning_config.organization_type') }}
                  </template>
                  <b-form-select
                  plain
                  v-model="search.org_type_id"
                  :options="orgTypeList"
                  id="org_type_id"
                  >
                  <template v-slot:first>
                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                  </b-form-select>
                  </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                  <b-form-group
                  class="row"
                  label-cols-md="12"
                  label-cols-lg="4"
                  label-for="reg_org_id"
                  >
                  <template v-slot:label>
                  {{ $t('elearning_config.organization') }}
                  </template>
                  <b-form-select
                  plain
                  v-model="search.reg_org_id"
                  :options="regOrgList"
                  id="reg_org_id"
                  >
                  <template v-slot:first>
                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                  </b-form-select>
                  </b-form-group>
          </b-col>
             <b-col xs="12" sm="12" md="6" lg="6" xl="6">
               <b-form-group
                 class="row"
                 label-cols-md="12"
                 label-cols-lg="4"
                 :label="$t('trainer_trainee.name_of_division')"
                 label-for="division_id"
               >
                 <b-form-select
                   plain
                   v-model="search.division_id"
                   :options="divisionList"
                   id="division_id"
                 >
                   <template v-slot:first>
                     <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                   </template>
                 </b-form-select>
               </b-form-group>
             </b-col>
             <b-col xs="12" sm="12" md="6" lg="6" xl="6">
               <b-form-group
                 class="row"
                 label-cols-md="12"
                 label-cols-lg="4"
                 :label="$t('trainer_trainee.name_of_district')"
                 label-for="district_id"
               >
                 <b-form-select
                   plain
                   v-model="search.district_id"
                   :options="districtList"
                   id="district_id"
                 >
                   <template v-slot:first>
                     <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                   </template>
                 </b-form-select>
               </b-form-group>
             </b-col>
             <b-col xs="12" sm="12" md="6" lg="6" xl="6">
               <b-form-group
                 class="row"
                 label-cols-md="12"
                 label-cols-lg="4"
                 :label="$t('trainer_trainee.name_of_upazilla')"
                 label-for="upazila_id"
               >
                 <b-form-select
                   plain
                   v-model="search.upazila_id"
                   :options="upazilaList"
                   id="upazila_id"
                 >
                   <template v-slot:first>
                     <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                   </template>
                 </b-form-select>
               </b-form-group>
             </b-col>
          </b-row>
          <b-row>
          <b-col lg="12" md="6" sm="12" class="text-right">
            <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('application_management.approve_list') }} {{$t('globalTrans.list')}}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" :to="'/training-e-learning-service/information-application-management/make-application-approval'">
              {{  $t('globalTrans.add_new') }}
            </b-button>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                      <template v-slot:cell(index)="data">
                          {{ $n(data.index + pagination.slOffset, {useGrouping: false}) }}
                      </template>
                      <template v-slot:cell(fiscal_year_id)="data">
                          {{currentLocale === 'bn'? GetYear(data.item.fiscal_year_id).text_bn: GetYear(data.item.fiscal_year_id).text_en}}
                      </template>
                      <template v-slot:cell(date_of_birth)="data">
                          {{data.item.date_of_birth | dateFormat}}
                      </template>
                      <template v-slot:cell(traineePhoto)="data">
                          <img style="width: 50px; height: 50px; border-radius: 50%" :src="trainingElearningServiceBaseUrl + 'download-attachment?file=uploads/trainee/profile/'+data.item.trainee.photo" alt="">
                      </template>
                      <template v-slot:cell(designationName)="data">
                          {{ data.item.trainee.other_designation ? data.item.trainee.other_designation : (currentLocale === 'bn' ? data.item.trainee.designation.designation_bn : data.item.trainee.designation.designation) }}
                      </template>
                    <template v-slot:cell(status)="data">
                      <span class="badge badge-warning" v-if="data.item.status == -1">{{$t('globalTrans.on_process')}}</span>
                      <span class="badge badge-primary" v-if="data.item.status == 0">{{$t('application_management.sort_list')}}</span>
                      <span class="badge badge-info" v-if="data.item.status == 1">{{$t('application_management.forwarded')}}</span>
                      <span class="badge badge-info" v-if="data.item.status == 2">{{$t('application_management.final')}}</span>
                      <span class="badge badge-success" v-if="data.item.status == 3">{{$t('application_management.approved')}}</span>
                      <span class="badge badge-dark" v-if="data.item.status == 4">{{$t('application_management.released')}}</span>
                    </template>
                      <template v-slot:cell(action)="data">
                          <div style="width: 80px">
                              <b-button v-b-modal.modal-2 variant=" iq-bg-success mr-1 mb-1" size="sm" @click="view(data.item, trainingElearningServiceBaseUrl + 'download-attachment?file=uploads/trainee/profile/'+data.item.trainee.photo)"><i class="ri-eye-fill m-0"></i></b-button>
                          </div>
                      </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-2" size="xl" :title="ViewTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Details :items="items" :key="viewitemId"/>
    </b-modal>
  </b-container>
</template>
<script>
import Details from '../application/Details'
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { applicationApproveList, applicationToggle, applicationApproveRemove } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import ConfirmationPopup from '@/Utils/confirmation-message'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    Details
  },
  data () {
    return {
        trainingElearningServiceBaseUrl: trainingElearningServiceBaseUrl,
      search: {
        fiscal_year_id: 0,
        training_title_id: 0,
        org_type_id: 0,
        reg_org_id: 0,
        division_id: 0,
        district_id: 0,
        upazila_id: 0
      },
      editItemId: 0,
      viewitemId: 0,
      rows: [],
      regOrgList: [],
        items: [],
      divisionList: [],
      districtList: [],
      upazilaList: []
    }
  },
  computed: {
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
          } else {
              return { value: obj.value, text: obj.text_en }
          }
      })
    },
    trainingNameList: function () {
            return this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1).map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
    },
    orgTypeList: function () {
            return this.$store.state.TrainingElearning.commonObj.organizationTypeList.filter(item => item.status === 1).map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
    formTitle () {
      return (this.editItemId === 0) ? this.$t('application_management.application') : this.$t('application_management.application') + ' ' + this.$t('globalTrans.modify')
    },
    ViewTitle () {
      return this.$t('application_management.application') + ' ' + this.$t('globalTrans.details')
    },
    currentLocale () {
      return this.$i18n.locale
    },
      columns () {
          const labels = [
              { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
              { label: this.$t('trainer_trainee.photo'), class: 'text-left' },
              { label: this.$t('elearning_config.name'), class: 'text-left' },
              { label: this.$t('elearning_config.designation'), class: 'text-center' },
              { label: this.$t('trainer_trainee.org_name'), class: 'text-center' },
              { label: this.$t('application_management.fiscal_year'), class: 'text-center' },
              { label: this.$t('trainer_trainee.circular_memo_no'), class: 'text-center' },
              { label: this.$t('trainer_trainee.training_title'), class: 'text-center' },
              { label: this.$t('globalTrans.status'), class: 'text-center' },
              { label: this.$t('globalTrans.action'), class: 'text-center' }
          ]

          let keys = []

          if (this.$i18n.locale === 'bn') {
              keys = [
                  { key: 'index' },
                  { key: 'traineePhoto' },
                  { key: 'trainee.name_bn' },
                  { key: 'designationName' },
                  { key: 'trainee.org.org_bn' },
                  { key: 'fiscal_year_id' },
                  { key: 'circular.circular_memo_no' },
                  { key: 'training.training_title_bn' },
                  { key: 'status' },
                  { key: 'action' }
              ]
          } else {
              keys = [
                  { key: 'index' },
                  { key: 'traineePhoto' },
                  { key: 'trainee.name' },
                  { key: 'designationName' },
                  { key: 'trainee.org.org' },
                  { key: 'fiscal_year_id' },
                  { key: 'circular.circular_memo_no' },
                  { key: 'training.training_title' },
                  { key: 'status' },
                  { key: 'action' }
              ]
          }
          return labels.map((item, index) => {
              return Object.assign(item, keys[index])
          })
      }
  },
  watch: {
    'search.org_type_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
          this.getRegOrgList(newVal)
        }
      this.search.reg_org_id = 0
    },
    'search.division_id': function (newVal, oldVal) {
      this.districtList = this.getDistrictList(newVal)
      this.upazilaList = []
      this.search.district_id = 0
      this.search.upazila_id = 0
    },
    'search.district_id': function (newVal, oldVal) {
      this.upazilaList = this.getUpazilaList(newVal)
    },
    currentLocale: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getDivisionList()
        if (this.search.org_type_id) {
          this.getRegOrgList(this.search.org_type_id)
        }
        if (this.search.org_type_id) {
          this.getRegOrgList(this.search.org_type_id)
        }

        if (this.search.division_id) {
          this.districtList = this.getDistrictList(this.search.division_id)
        }
        if (this.search.district_id) {
          this.upazilaList = this.getUpazilaList(this.search.district_id)
        }
      }
    }
  },
  created () {
      this.loadData()
    this.getDivisionList()
  },
  mounted () {
  },
  methods: {
      GetYear (id) {
          return this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
      },
      unsorted (id) {
          var message = window.vm.$t('application_management.remove_approve_list') + '?'
          ConfirmationPopup(message, (response) => {
              if (response === true) {
                  this.loadingBtn = true
                  this.$store.dispatch('mutateCommonProperties', { loading: true })
                const loadingState = { loading: false, listReload: true }
                  RestApi.getData(trainingElearningServiceBaseUrl, applicationApproveRemove + '/' + id).then(response => {
                      this.$store.dispatch('mutateCommonProperties', loadingState)
                      if (response.success) {
                          this.$toast.success({
                              title: this.$t('globalTrans.success'),
                              message: this.$t('globalTrans.update_msg'),
                              color: '#D6E09B'
                          })
                          this.$bvModal.hide('modal-4')
                      } else {
                          this.$toast.error({
                              title: this.$t('globalTrans.error'),
                              message: this.$t('globalTrans.operationFailed')
                          })
                      }
                  })
              }
          })
      },
      view (viewitem, url) {
          viewitem.url = url
          this.items = viewitem
      },
    edit (edititem) {
      this.editItemId = edititem.id
    },
    searchData () {
      this.loadData()
    },
    remove (item) {
      this.changeStatus(trainingElearningServiceBaseUrl, applicationToggle, item)
    },
    async getRegOrgList (typeId) {
       this.regOrgList = this.$store.state.TrainingElearning.commonObj.registeredOrgList.filter(item => item.organization_type_id === typeId && item.status === 1).map((obj, key) => {
           if (this.$i18n.locale === 'bn') {
               return { value: obj.value, text: obj.text_bn }
           } else {
               return { value: obj.value, text: obj.text_en }
           }
       })
     },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(trainingElearningServiceBaseUrl, applicationApproveList, params).then(response => {
          if (response.success) {
            // this.$store.dispatch('setList', response.data.data)
            this.$store.dispatch('setList', this.getRelationalData(response.data.data))
            this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getRelationalData (data) {
            const qualifList = this.$store.state.TrainingElearning.commonObj.eduQualificationList.filter(item => item.status === 1)
            const listData = data.map(item => {
              const qualifObj = qualifList.find(quaItem => item.value === quaItem.qualification_id)
               const data = {
                    qualification: (qualifObj.text_en !== undefined) ? qualifObj.text_en : '',
                    qualification_bn: (qualifObj.text_bn !== undefined) ? qualifObj.text_bn : ''
                }
                const dtObj = {
                    // date_of_birth: new Date(item.dob + (8 * 86400000) + 'Z').toLocaleString('en-US', {
                    date_of_birth: new Date(Date.now()).toLocaleString('en-US', {
                      timeZone: 'UTC',
                      day: '2-digit',
                      // month: '2-digit',
                      month: 'short',
                      year: 'numeric'
                  })
                }
                return Object.assign({}, item, data, dtObj)
            })
            return listData
    },
    getOfficeTypeList () {
        this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    orgName (orgId) {
      const orgName = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId)
      if (this.$i18n.locale === 'bn') {
        return orgName.text_bn
      } else {
        return orgName.text_en
      }
    },
    getOfficeTypeName (typeId) {
      const TypeName = this.$store.state.commonObj.officeTypeList.find(item => item.value === typeId)
      if (this.$i18n.locale === 'bn') {
        return TypeName.text_bn
      } else {
        return TypeName.text
      }
    },
    getInstituteName (InstId) {
      const institute = this.$store.state.commonObj.officeList.find(institute => institute.value === InstId)
      if (this.$i18n.locale === 'bn') {
        return institute.text_bn
      } else {
        return institute.text_en
      }
    },
    getOfficeList () {
        this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getDivisionList () {
      this.divisionList = this.$store.state.commonObj.divisionList.filter(item => item.status === 0).map(obj => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    getDistrictList (divisionId = null) {
      const districtPerList = this.$store.state.commonObj.districtList
      if (divisionId) {
        return districtPerList.filter(district => district.division_id === divisionId).map(obj => {
          if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: obj.text_bn }
          } else {
            return { value: obj.value, text: obj.text_en }
          }
        })
      }
      return districtPerList.map(obj => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    getUpazilaList (districtId = null) {
      const upazilaPerList = this.$store.state.commonObj.upazilaList
      if (districtId) {
        return upazilaPerList.filter(upazila => upazila.district_id === districtId).map(obj => {
          if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: obj.text_bn }
          } else {
            return { value: obj.value, text: obj.text_en }
          }
        })
      }
      return upazilaPerList.map(obj => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    }
  }
}
</script>
